import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import UserState from '../../types/UserState'

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    user_status: '',
    cards: [],
    otp_modal: false,
    fee_calculation_running: false,
    ipay_fee: 0,
    ipay_link: '',
    ipay_link_running: false
  },
  getters,
  actions,
  mutations
}
